export default __webpack_public_path__ + "static/Corporate_Responsibility_Philantrophic_32-e3b9f2daa1994d9becc5125edb329ed5.jpg";